import { positionOfCategoiresBlog, positionOfPackags, statusOfCategoriesBlog } from "../../../lib/definitions";
import i18n from "../../../lib/i18n";
import AddCategoiresBlogUi from "../../../ui/categoriesBlog/addCategoriesBlogUi";

export default function AddCategoiresBlog () {

    const t = i18n.t.bind(i18n); 

    return(
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("add_page_title.category")}</h1>
                <AddCategoiresBlogUi positionOfCategoiresBlog={positionOfCategoiresBlog} statusOfCategoriesBlog={statusOfCategoriesBlog}  />
            </div>
        </div>
    );
};